<template>
  <article>
    <div ref="header">
      <search-input
        v-model="queryForm.plate_number"
        placeholder-word="请输入车牌号码"
        @on-search="search">
      </search-input>
    </div>

    <!-- height要算准确 -->
    <scroller
      lock-x scrollbar-y
      use-pullup
      ref='myScroller'
      @on-pullup-loading="loadMore"
      :pullup-config="pullConfig"
      :height="scrollerHeight">
      <div class="mt-20">
        <group v-for="(item,index) in dataList" :key="index">
          <cell class="cou-cell">
            <p slot="after-title"><span class="cou-label">业务员：</span>{{item.offerer.name}}</p>
            <p slot="after-title"><span class="cou-label">客户类型：</span>{{item.car.insurance_rating}}</p>
            <p slot="after-title"><span class="cou-label">车牌号：</span>{{item.car.plate_number}}</p>
            <p slot="after-title"><span class="cou-label">续保金额：</span>￥{{item.quote_price | formatePrice}}</p>
            <p slot="after-title" class="mb50"><span class="cou-label">提交时间：</span>{{item.edited_at}}</p>
            <p slot="after-title" v-for="(v, i) in item.coupon_batches" :key="i">
              <em class="icon-price"></em>
              <em>{{v.title}},</em>
              <em v-if="v.face_value">价值{{v.face_value | formatePrice}}元,</em>
              <em v-html="v.issue_count"></em>张
            </p>
          </cell>
          <cell>
            <div slot="value">
              <a class="btn-pass-no" @click.stop="onCheck('reject', item, index)" v-if="item.status === 'pending_review'?  reviewer : false">审核不通过</a>&nbsp;&nbsp;
              <a class="btn-pass" @click.stop="onCheck('approve', item, index)" v-if="item.status === 'pending_review'?  reviewer : false">审核通过</a>
              <a class="btn-check-ok" v-else>{{statusTxt[item.status]}}</a>
            </div>
          </cell>
        </group>
        <p class="tip-text1">共{{totalCount}}条记录</p>
      </div>
    </scroller>
  </article>
</template>
<script>
import {
  Scroller,
  Cell,
  Group
} from '@lx-frontend/cvux'
import SearchInput from '../components/SearchInput'

export default {
  components: {
    SearchInput,
    Scroller,
    Cell,
    Group
  },
  data() {
    return {
      statusTxt: {
        pending_review: '待审核',
        review_rejected: '审核不通过',
        published: '审核通过',
        pending_payment: '待支付',
        paid: '已支付',
        finished: '已完成',
        closed: '关闭'
      },
      isTapDone: false, // 请求结束前禁止再次点击
      pullConfig: {
        content: '',
        downContent: '',
        upContent: '',
        loadingContent: '加载中...'
      },
      reviewer: false,
      totalCount: 0,
      totalPage: 0,
      queryForm: {
        count: 10,
        page: 1,
        plate_number: ''
      },
      dataList: [],
      scrollerHeight: ''
    }
  },
  filters: {
    formatePrice(price) {
      return (price / 100).toFixed(2)
    }
  },
  mounted() {
    this.scrollerHeight = `-${this.$refs.header.offsetHeight}px`
    this.getData()
  },
  methods: {
    search() {
      this.queryForm.page = 1
      this.totalCount = 0
      this.totalPage = 0
      this.getData()
    },
    getData() {
      this.$rest.cou.checkList.renewalList(this.queryForm).then(res => {
        if (res.code === 0) {
          let data = res.data
          let count = this.queryForm.count
          this.reviewer = data.reviewer
          this.dataList = data.list
          this.totalCount = data.total_count
          this.totalPage = parseInt((this.totalCount + count - 1) / count)
          this.$nextTick(() => {
            if (this.$refs.myScroller) {
              this.$refs.myScroller.reset({
                top: 0
              })
            }
          })
        } else {
          this.showToast(res.message)
        }
      })
    },
    loadMore(done) {
      if (this.queryForm.page < this.totalPage) {
        ++this.queryForm.page
        this.$rest.cou.checkList.renewalList(this.queryForm).then(res => {
          if (res.code === 0) {
            let data = res.data
            let count = this.queryForm.count
            this.totalCount = data.total_count
            this.totalPage = parseInt((this.totalCount + count - 1) / count)
            this.reviewer = data.reviewer
            this.dataList.push(...data.list)
            done(100)
          } else {
            this.showToast(res.message)
          }
        })
      } else {
        done()
      }
    },
    // 审核
    onCheck(action, item, index) {
      if (this.isTapDone) {
        return false
      }
      this.isTapDone = true
      this.$rest.cou.checkRenewal({
        action: action
      }, item.quote_id + '/review').then(res => {
        if (res.code === 0) {
          if (action === 'reject') {
            this.dataList[index].status = 'review_rejected'
          } else if (action === 'approve') {
            this.dataList[index].status = 'published'
          }
          this.isTapDone = false
        } else {
          this.isTapDone = false
          this.showToast(res.message)
        }
      })
    }
  }
}

</script>
<style lang="less">
@w2: 75rem;
.cou-cell .weui_cell_primary p {
  p {
    line-height: 1.8;
    .cou-label {
      width: 228/@w2;
      display: inline-block;
      opacity: 0.4;
    }
  }
  .mb50 {
    margin-bottom: 40/@w2;
  }
}

</style>
